// ----------------------------
// Created by Bulletproof Games
//            2022
//  www.bulletproofgames.co.uk
// ----------------------------
//
// GoldenBet Toggle Button ( based on LuckyBetToggle )

goldenBetToggleButton = {};

goldenBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.goldenBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showGoldenBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canPlaceBet = false;

  button._potBonusActive = false;
  button._gbBacking = undefined;
  button._gbButtonText = undefined;

  button.shuffle = resourceManager.get('shuffler');

  //////////////////////////////////////////
  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.GOLDENBET_BUY.coinSizes;
    const baseStake = resourceManager.getController('stakeController').BaseStake / 20;
    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      button.canPlaceBet &&
      goldenbetStakes.length !== 0 &&
      !gdk.serverParser._inReplayMode;

    var buttonToDim = button._flags.showGoldenBetActive ? this.button.buttonEnabled : this.button.buttonDisabled;

    buttonToDim.alpha = allow ? 1 : 0.5;

    if (button._gbBacking) {
      button._gbBacking.alpha = buttonToDim.alpha;
    }

    if (button._gbButtonText) {
      button._gbButtonText.alpha = buttonToDim.alpha;
    }

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet && this._flags.platformEnabled;
  };

  //////////////////////////////////////////
  button.onConfig = function (config) {
    this.gameConfig = config;
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;
  };

  //////////////////////////////////////////
  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  //////////////////////////////////////////
  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
    messageBus.subscribe('game:previousStakeAndMode', button.onPreviousStakeAndMode.bind(button));
  };

  ///////////////////////////////////////////////
  button.onLayoutComplete = function () {
    button.goldenBetMessage = resourceManager.get('goldenBetMessage');
    button.animParent = resourceManager.get('goldenBetToggleButton');

    // create here on top of button
    button.goldenBetAnim = resourceManager.createObject('movie', 'goldenBetAnim', button.animParent, {
      definition: 'goldenBet',
      x: 0,
      y: 0,
      loop: false,
      anchor: 0.5,
      scale: 1,
    });
    button.goldenBetAnim.gotoAndStop(0);
    button.goldenBetAnim.visible = false;

    button.goldenBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;

    // Expand hit area to cover the full backing sprite
    button._gbBacking = resourceManager.get('goldenBetToggleButton:goldenBetBacking');
    if (button._gbBacking && button.button) {
      const backingWidth = button._gbBacking.width;
      const backingHeight = button._gbBacking.height;
      const yOffset = -backingHeight / 2 + 47;
      button.button.hitArea = new PIXI.Rectangle(-backingWidth / 2, yOffset, backingWidth, backingHeight);
    }

    button._gbButtonText = resourceManager.get('goldenBetToggleButton:goldenBetButtonText1');
  };

  button.goldenBetAllowed = function () {
    return this._flags.platformVisible && !gameController.inShuffle;
  };

  //////////////////////////////////////////
  button.canShow = function () {
    // Dont show in freespins
    return !this.shuffle._inShuffle && gdk.getPlatformAllowsUpstake();
  };

  //////////////////////////////////////////
  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showGoldenBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
      this.visible = true;
    } else {
      if (!this.goldenBetAllowed()) {
        this.button.visible = false;
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = false;
        this.visible = false;
      }
    }
  };

  //////////////////////////////////////////
  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable golden bet
    button._flags.showGoldenBetActive = false;
    button.cancelGoldenBet();
  };

  //////////////////////////////////////////
  button.cancelGoldenBet = function () {
    button.goldenBetAnim.gotoAndStop(0);
    button.goldenBetAnim.visible = false;
    if (button.goldenBetMessage !== undefined) {
      button.goldenBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.goldenBetAnim.gotoAndStop(0);
      button.goldenBetAnim.visible = false;

      gameData.encoreEnabled = false;

      const stake = button.handleStakeChange();
      gameController.currentNonBABStake = stake;
      // Show persistence message if progress was saved on previous stake
      if (gameController.showStakeChangeMessage) {
        gameController.displayStakeChangePersistenceMessage();
        gameController.showStakeChangeMessage = false;
      }
    }
  };

  //////////////////////////////////////////
  button.handleStakeChange = function () {
    let goldenBetEnabled = gameData.encoreEnabled;
    let stakeController = resourceManager.getController('stakeController');
    persistence.setCurrentMode(goldenBetEnabled ? 'GOLDENBET_BUY' : 'BASIC');

    stakeController.setStakeMultiplier(goldenBetEnabled ? 1.5 : 1);
    stakeController.broadcastCurrentStake(); // Broadcast first - triggers persistence check
    const stake = stakeController.BaseStake * (goldenBetEnabled ? 1.5 : 1);
    gameController.onStakeChanged(stake); // Then update UI

    return stake;
  };

  button.onPreviousStakeAndMode = function (data) {
    if (data.lastMode === 1) {
      button.setRecovery();
    }
  };

  //////////////////////////////////////////
  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as golden bet active
    button._flags.showGoldenBetActive = true;
    gameData.encoreEnabled = true;
    button.handleStakeChange();
  };

  //////////////////////////////////////////

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onSpin = function () {
    button.goldenBetAnim.gotoAndStop(0);
    button.goldenBetAnim.visible = false;
    if (button.goldenBetMessage !== undefined) {
      button.goldenBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    }
  };

  //////////////////////////////////////////
  button.onPressedCallback = function () {
    button._flags.showGoldenBetActive = !button._flags.showGoldenBetActive;

    if (button._flags.showGoldenBetActive) {
      soundManager.play('golden_bet_on');
      if (button.goldenBetMessage !== undefined) {
        button.goldenBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(4000, undefined, function () {
          button.innerFadeTimer = timerManager.addTimer(
            250,
            function (progress) {
              button.goldenBetMessage.alpha = 1 - progress;
            },
            function () {
              button.goldenBetMessage.alpha = 0.0;
            }
          );
        });

        button.goldenBetAnim.visible = true;
        button.goldenBetAnim.onComplete = function () {
          button.goldenBetAnim.visible = false;
          button.goldenBetAnim.gotoAndStop(0);
        };
        button.goldenBetAnim.gotoAndPlay(0);

        gameData.encoreEnabled = true;
        button.handleStakeChange();
        // Show persistence message if progress was saved on previous stake
        if (gameController.showStakeChangeMessage) {
          gameController.displayStakeChangePersistenceMessage();
          gameController.showStakeChangeMessage = false;
        }
      }
    } else {
      soundManager.play('golden_bet_off');
      button.cancelGoldenBet();
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable golden bet
    button._flags.showGoldenBetActive = false;
    button.cancelGoldenBet();
  };

  return button;
};

goldenBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

goldenBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'goldenBetToggleButton',
  goldenBetToggleButton.create,
  goldenBetToggleButton.initialise,
  goldenBetToggleButton.getFilesRequired
);
